/**
 * MODULE: brainAlertsNavCount.ts
 * PURPOSE: Derive top-nav advisor alert badge count from assistant brain context.
 * RECENT: 2026-07-08 [2.2.1478] — Count structured risk_alerts for BrainAlertsNavBadge.
 * AGENT SAFETY: SAFE
 * FILE_SIZE: 18 / 150 lines
 */

import type {
  AssistantContextResponse,
  AssistantRiskAlert,
} from '@shared/lib/frontend/api/assistantContextApi';

/** Risk alerts with a title — same filter as assistant context rail. */
export function brainAlertsNavVisibleAlerts(
  context: AssistantContextResponse | null,
): AssistantRiskAlert[] {
  if (!context?.risk_alerts?.length) return [];
  return context.risk_alerts.filter((alert) => (alert.title || '').trim());
}

export function brainAlertsNavBadgeCount(context: AssistantContextResponse | null): number {
  return brainAlertsNavVisibleAlerts(context).length;
}
